import PropTypes from 'prop-types';
import ImageProp from '../../../commonComponents/propTypes/imageProp';
import CategoryProp from './categoryProp';
import ProductVariationProp from './productVariationsProp';
import ProductOwnerProp from './productOwner';
import i18n from '../../../services/i18n';

export const PRODUCT_STATUS = {
  NA: 'NA',
  ACTIVE: 'active',
  DISABLED: 'disable',
};

export const PRODUCT_STATUSES = [
  { id: PRODUCT_STATUS.NA, text: 'N/A' },
  { id: PRODUCT_STATUS.ACTIVE, text: i18n.__('active') },
  { id: PRODUCT_STATUS.DISABLED, text: i18n.__('inactive') },
];

const propType = {
  _id: PropTypes.string,
  name: PropTypes.string,
  description: PropTypes.string,
  summary: PropTypes.string,
  slug: PropTypes.string,
  category: PropTypes.shape(CategoryProp.propType),
  type: PropTypes.string,
  sku: PropTypes.string,
  owner: PropTypes.oneOfType([
    PropTypes.shape(ProductOwnerProp.propType),
    PropTypes.string,
  ]),
  availableForSubscription: PropTypes.bool,
  availableSubscriptionFrequency: PropTypes.arrayOf(PropTypes.string),
  user: PropTypes.string,
  userViews: PropTypes.number,
  viewCount: PropTypes.number,
  highlight: PropTypes.bool,
  variations: PropTypes.arrayOf(PropTypes.shape(ProductVariationProp.propType)),
  images: PropTypes.arrayOf(PropTypes.shape(ImageProp.propType)),
  customTabs: PropTypes.shape({
    _id: PropTypes.string,
    translationsName: PropTypes.objectOf(PropTypes.string),
    translationsContent: PropTypes.objectOf(PropTypes.string),
    name: PropTypes.string,
    content: PropTypes.string,
    position: PropTypes.number,
  }),
};

const defaultProp = {
  isPack: false,
  variations: [],
  images: [],
  customTabs: [],
};

export const PRODUCT_STATIC_TAB = {
  DESCRIPTION: 'description',
  SPECIFICATIONS: 'specifications',
};

export const PACK_TYPE = {
  NORMAL_PACK: 'normal',
  ADVANCED_PACK: 'advanced',
};

export const PACK_TYPES = Object.values(PACK_TYPE);

export default { propType, defaultProp };
